import React, { useState } from "react";
import { Button, Form, Container, Row, Col, Modal } from "react-bootstrap";
import '../styles/NewCampaign.css';
import { addCampaigns } from "../services/api";
import InfluencerSelection from './InfluencerSelection';

const NewCampaign = ({ isOpen, handleClose }) => {
    const [campaignName, setCampaignName] = useState("");
    const [campaignDescription, setCampaignDescription] = useState("");
    const [brandName, setBrandName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [campaignCost, setCampaignCost] = useState("");
    const [errors, setErrors] = useState({});
    const [showInfluencerSelection, setShowInfluencerSelection] = useState(false);
    const [newCampaignID, setNewCampaignID] = useState(null);

    const validateForm = () => {
        let formErrors = {};
        if (!campaignName) formErrors.campaignName = "Campaign name is required";
        // if (!brandName) formErrors.brandName = "Brand name is required";
        if (!startDate) formErrors.startDate = "Start date is required";
        if (!endDate) formErrors.endDate = "End date is required";
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            const newCampaign = {
                Name: campaignName,
                Description: campaignDescription,
                Brand: "",
                StartDate: startDate,
                EndDate: endDate,
                Budget: campaignCost
            };
            try {
                const response = await addCampaigns(newCampaign);
                setNewCampaignID(response.data.campaignID);
                setShowInfluencerSelection(true);
            } catch (error) {
                console.error("Error creating campaign:", error);
            }
        }
    };

    const handleInfluencerSelectionClose = () => {
        setShowInfluencerSelection(false);
        handleClose();
    };

    return (
        <>
            <Modal show={isOpen} onHide={handleClose} centered className="new-campaign-modal-width">
                <Modal.Header closeButton>
                    <Modal.Title>Create a new campaign</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Campaign Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter campaign name"
                                value={campaignName}
                                onChange={(e) => setCampaignName(e.target.value)}
                            />
                            {errors.campaignName && <small className="text-danger">{errors.campaignName}</small>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Campaign Description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter campaign description"
                                value={campaignDescription}
                                onChange={(e) => setCampaignDescription(e.target.value)}
                            />
                        </Form.Group>
                        {/* <Form.Group className="mb-3">
                            <Form.Label>Brand Name</Form.Label>
                            <Form.Select value={brandName} onChange={(e) => setBrandName(e.target.value)}>
                                <option value="">Select brand</option>
                                <option value="Brand A">Brand A</option>
                                <option value="Brand B">Brand B</option>
                            </Form.Select>
                            {errors.brandName && <small className="text-danger">{errors.brandName}</small>}
                        </Form.Group> */}
                        <Form.Group className="mb-3">
                            <Form.Label>📅 Campaign Duration</Form.Label>
                            <p className="text-muted">We actively update the campaign performance details in this duration.</p>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                    {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                    {errors.endDate && <small className="text-danger">{errors.endDate}</small>}
                                </Col>
                            </Row>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>💰 Campaign Cost (Optional)</Form.Label>
                            <p className="text-muted">We use it to calculate performance metrics (cost per view, and more).</p>
                            <div className="d-flex align-items-center">
                                <span className="me-2">$USD</span>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter campaign cost"
                                    value={campaignCost}
                                    onChange={(e) => setCampaignCost(e.target.value)}
                                />
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit}>Next</Button>
                </Modal.Footer>
            </Modal>

            <InfluencerSelection
                isOpen={showInfluencerSelection}
                handleClose={handleInfluencerSelectionClose}
                campaignID={newCampaignID}
            />
        </>
    );
};

export default NewCampaign;
